import {handleError, headerset} from "../apiUtils";
import {ErrorsStack, ErrorStatusTypes} from "../../components/common/errorsDeclarations";


export function getParametri() {

    const url = `${process.env.API_URL}/api/ticketing/parametri/`;
    return fetch(url, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: headerset().Authorization,
        },
    })
        .then((response: any) => {
            return response.json()
        })
        .catch(handleError);

}


export interface ParametriTicketing {
    id?: number;
    utente?: string;
    password?: string;
    url?: string;
    applicativo?: string;
    authorization?: string;
    // testo: string;
    // created_at: string | DateTime | Date;
    // updated_at: string | DateTime | Date;
}

export function ticketingTokenObtain(parametriTicketing: ParametriTicketing) {
    return fetch(parametriTicketing.url + "/api/token/obtain/", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
        },
        body: JSON.stringify({
            username: parametriTicketing.utente,
            password: parametriTicketing.password,
        }),
    })
        .then((response: any) => {
            return response.json()
        })
        .catch(handleError);
}


export async function getParametriTicketingApi(): Promise<ParametriTicketing> {
    let parametriTicketing: ParametriTicketing = {
        url: "",
    }
    const parametri = await getParametri();
    const token:{access?:string; refresh?:string; code?:string} = await ticketingTokenObtain(parametri);
    if (token.code) {
        throw "Errore di autenticazione";
    }
    const authorization = "Bearer " + token.access;
    parametriTicketing = {...parametri, url: parametri.url, authorization: authorization}
    return parametriTicketing
}